import type { ContactNeed } from "@/lib/contact";
import type { SitePage } from "@/lib/site-pages";

/**
 * Use-case pages: one trade or situation each, rendered by the same template
 * from `useCases.items.<key>` in the dictionaries.
 */
export const USE_CASES = {
	hvac: {
		page: "useCaseHvac",
		to: "/{-$locale}/cas-usage/maintenance-cvc",
		need: "businessApps",
	},
	qhse: {
		page: "useCaseQhse",
		to: "/{-$locale}/cas-usage/cabinet-qhse",
		need: "businessApps",
	},
	cleaning: {
		page: "useCaseCleaning",
		to: "/{-$locale}/cas-usage/controle-qualite-proprete",
		need: "businessApps",
	},
	takeover: {
		page: "useCaseTakeover",
		to: "/{-$locale}/cas-usage/reprise-application-react-native",
		need: "expoMigration",
	},
} as const satisfies Record<
	string,
	{ page: SitePage; to: string; need: ContactNeed }
>;

export type UseCaseKey = keyof typeof USE_CASES;

export const USE_CASE_KEYS = Object.keys(USE_CASES) as UseCaseKey[];
